{
  "title": "Add Related Entity",
  "relationship": "Relationship",
  "relationshipTo": "Relationship to {{whom}}",
  "alreadyRelatedTo": "Entity is already related to",
  "thisClient": "this client",
  "pleaseReview": "Please review your information to ensure it’s correct.",
  "name": "Name",
  "continue": "Continue",
  "added": "{{entityName}} has been added as a related entity",
  "failed": "Adding a new related entity failed.",
  "done": "Done"
}
